import { AUTHENTICATION_PENDING, LOGIN_SUCCESS, LOGIN_FAILURE, LOGOUT_SUCCESS, LOGOUT_FAILURE } from '../actions/authentication.actions';

const INITIAL_AUTHENTICATION_STATE = {
  authenticated: false,
  currentUser: null,
  loading: false,
  error: false,
  logoutError: false
};

const authenticationReducer = (state = INITIAL_AUTHENTICATION_STATE, action = {}) => {

  switch (action.type) {

    case AUTHENTICATION_PENDING:
      return { ...state, loading: true, error: false };

    case LOGIN_SUCCESS:
      return { ...state, loading: false, authenticated: true, currentUser: action.payload.currentUser };

    case LOGIN_FAILURE:
      return { ...state, loading: false, error: true };

    case LOGOUT_SUCCESS:
      return { ...state, loading: false, authenticated: false, currentUser: null, logoutError: false };

    case LOGOUT_FAILURE:
      return { ...state, loading: false, authenticated: false, currentUser: null, logoutError: true };

    default:
      return state;
  }
};

export default authenticationReducer;
